import type { ValueFormatterParams } from "ag-grid-community";

import { CustomerNameLink } from "~/modules/customers/CustomerNameLink";

export const LinkCellRenderer = (params: ValueFormatterParams<string>) => {
  const row = params?.data as { customerId?: string; customerViewInScope?: boolean } | undefined;
  const customerId = row?.customerId ?? "";
  const customerViewInScope = row?.customerViewInScope === true;
  const label = (params?.value as string) || "";

  return (
    <div
      style={{
        padding: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        minWidth: 0,
        maxWidth: "100%",
        display: "block",
      }}
    >
      {customerId ? (
        <CustomerNameLink customerId={customerId} customerViewInScope={customerViewInScope} onClick={e => e.stopPropagation()}>
          {label}
        </CustomerNameLink>
      ) : (
        <span>{label}</span>
      )}
    </div>
  );
};
